import {
  CoursesFilter,
  CoursesFilterApi,
  CoursesFilterOption,
  CoursesFilterOptionApi,
  CoursesFilterOptionsApi,
  CoursesFilterOptionsApiResponse,
  CoursesFiltersApi,
  CoursesFiltersApiResponseModel,
} from './coursesFilters.model';
import { filtersAdapter } from '../../../adapters';
import { FiltersModel } from '../../../catalog';

export const courseFilterOptionAdapter = (
  option: CoursesFilterOptionApi
): CoursesFilterOption => ({
  key: option.slug,
  value: option.value,
});

export const courseFilterOptionsAdapter = (
  options: CoursesFilterOptionApi[]
): CoursesFilterOption[] => options.map(courseFilterOptionAdapter);

export const courseFilterOptionsApiAdapter = (
  response: CoursesFilterOptionsApi
): CoursesFilterOption[] => courseFilterOptionsAdapter(response.data);

export const courseFilterOptionsApiResponseAdapter = ({
  data,
}: CoursesFilterOptionsApiResponse): CoursesFilterOption[] =>
  courseFilterOptionsAdapter(data.data.options.data);

export const coursesFilterApiAdapter = (
  response: CoursesFilterApi[]
): CoursesFilter[] => response.map(coursesFilterAdapter);

export const coursesFiltersApiAdapter = (
  response: CoursesFiltersApi
): CoursesFilter => coursesFiltersAdapter(response.data);

export const coursesFilterAdapter = (
  coursesFilter: CoursesFilterApi
): CoursesFilter => ({
  [coursesFilter.slug]: courseFilterOptionsApiAdapter(coursesFilter.options),
});

export const coursesFiltersAdapter = (
  coursesFilters: CoursesFilterApi[]
): CoursesFilter =>
  coursesFilters.reduce(
    (acc: CoursesFilter, coursesFilter: CoursesFilterApi): CoursesFilter => {
      acc = Object.assign({}, acc, coursesFilterAdapter(coursesFilter));

      return acc;
    },
    {}
  );

export const coursesFiltersApiResponseAdapter = (
  response: CoursesFiltersApiResponseModel
): FiltersModel[] => filtersAdapter(response.data.data, {});
